import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-value',
  templateUrl: './value.component.html',
  styleUrls: ['./value.component.scss'],
  standalone: false,
})
export class ValueComponent implements OnInit, OnChanges {
  @Input() value: any;

  @Input() class: string = '';
  @Input() fontsize: string = '';
  @Input() success: boolean = false;
  @Input() warn: boolean = false;
  @Input() fail: boolean = false;
  @Input() critical: boolean = false;
  @Input() info: boolean = false;
  @Input() bold: boolean = true;
  @Input() bgFill: boolean = false;
  @Input() icon: string = '';
  @Input() useAppFont: boolean = true;
  @Input() suffix: string = '';
  @Input() header: string = '';
  @Input() size: 'small' | 'large' = 'small';
  @Input() light = false;
  @Input() border = false;
  @Input() subtitle: string = '';
  @Input() block: boolean = false;

  classes: string[] = [];
  style: { [key: string]: any } = {};

  constructor() {}

  ngOnInit() {
    this.classes = this.getClasses();
    if (this.fontsize !== '') {
      this.style['font-size'] = this.fontsize;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.classes = this.getClasses();
    if (this.fontsize !== '') {
      this.style['font-size'] = this.fontsize;
    }
  }

  getClasses(): string[] {
    const classes: string[] = [];

    if (this.class) {
      classes.push(this.class);
    }

    if (this.bgFill) {
      classes.push('background');
    } else {
      classes.push('foreground');
    }

    if (this.border) {
      classes.push('border');
    }

    if (this.success) {
      classes.push('success');
    }

    if (this.warn) {
      classes.push('warning');
    }

    if (this.fail) {
      classes.push('failure');
    }

    if (this.critical) {
      classes.push('critical');
    }

    if (this.info) {
      classes.push('information');
    }

    if (this.useAppFont) {
      classes.push('appFont');
    }

    if (this.bold) {
      classes.push('bold');
    }

    if (this.light) {
      classes.push('light');
    }

    return classes;
  }
}
